export enum LogLevel {
    DEBUG = 0,
    INFO,
    WARN,
    ERROR
}
